var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('titles',{attrs:{"titlename":"实训档案管理详情","titlecontent":"这里可以看到档案详情","mbx":_vm.paths}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }